import React from 'react';
import type { CustomElement } from '../../../types/aha-editor';
import styles from './ImageComponentPlugin.module.css';
import MediaCommon from '../MediaCommon';

interface MediaLoaderProps {
  element: Extract<CustomElement, { media_src: string }>;
  inline?: boolean;
}

const MediaLoader: React.FC<MediaLoaderProps> = ({
  element,
  inline = false,
}) => {
  if (!element || !element.media_src) {
    return null;
  }

  const isTemporaryImage = MediaCommon.isTemporaryDataUrl(element.media_src);
  if (!isTemporaryImage) {
    return null;
  }

  return (
    <div
      className={inline ? styles.loaderInline : styles.loader}
      contentEditable={false}
      inert
      data-aha-editor-placeholder
    >
      {/* We need to use rem because the <Resizer> reset font-size to 0 */}
      <aha-spinner size={inline ? '1rem' : '10cqw'} />
    </div>
  );
};

export default MediaLoader;
